let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1nsOG")).then(() => parcelRequire('9zjC3'));